import { render, staticRenderFns } from "./RequestInfoDetail.vue?vue&type=template&id=832ba924"
import script from "./RequestInfoDetail.vue?vue&type=script&lang=js"
export * from "./RequestInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports